import { gql } from "@apollo/client";

export const FETCH_MARKETTIME_ORDERS = gql`
  query FETCH_MARKETTIME_ORDERS {
    mtOrders
  }
`;

export const MT_SEND_ORDERS_TO_ODOO = gql`
  mutation MT_SEND_ORDERS_TO_ODOO($ordersString: String!) {
    mtSendOrdersToOdoo(ordersString: $ordersString) {
      result
    }
  }
`;

export const ODOO_SAVE_CUSTOMER = gql`
  mutation ODOO_SAVE_CUSTOMER(
    $instance: String!
    $id: Int!
    $xStudioMtRetailerId: String
    $xStudioMtAddressId: String
    $xStudioMtRepgroupId: String
  ) {
    odooSaveCustomer(
      instance: $instance
      id: $id
      xStudioMtRetailerId: $xStudioMtRetailerId
      xStudioMtAddressId: $xStudioMtAddressId
      xStudioMtRepgroupId: $xStudioMtRepgroupId
    ) {
      result
    }
  }
`;

export const FETCH_MT_ODOO_REPGROUPS = gql`
  query FETCH_MT_ODOO_REPGROUPS($markettimeRepgroupIds: [String]) {
    odooRepgroups: odooCustomers(
      instance: "INC"
      useType: "MT_REPGROUPS"
      markettimeRepgroupIds: $markettimeRepgroupIds
    )
  }
`;

export const FETCH_MT_ODOO_RETAILERS = gql`
  query FETCH_MT_ODOO_RETAILERS($markettimeRetailerIds: [String]) {
    odooCustomers(
      instance: "INC"
      useType: "MT_RETAILERS"
      markettimeRetailerIds: $markettimeRetailerIds
    )
  }
`;

export const FETCH_ODOO_PRODUCTS_WITH_MT_IDS = gql`
  query FETCH_ODOO_PRODUCTS_WITH_MT_IDS($markettimeProductIds: [String]) {
    odooProducts(
      instance: "INC"
      mtIds: $markettimeProductIds
      fields: ["x_studio_markettime_product_id"]
    )
  }
`;

export const FETCH_ODOO_MT_ORDERS = gql`
  query FETCH_ODOO_MT_ORDERS($sourceIds: [String]) {
    odooSaleOrders(instance: "INC", sourceId: 10, sourceIds: $sourceIds)
  }
`;
